<kilowant-header [isBuyer]="true" [myKilowant]="true"></kilowant-header>
<div class="wrapperMain mainAccountDetailsMain backgroundImage">
  <div class="form">
    <div class="card">
      <div class="right-margin">
         <a class="close-icon" (click)="cancel()">
           <div class="line1">
             <div class="line2"></div>
           </div>
         </a>
      </div>
      <div class="body">
          <h2>Order Details</h2>
            <div class="title">
              <p *ngIf="verificationPhase">A Seller accepted this order on {{newDate}} &#64; {{newTime}} EST. The Seller has <b>{{counter | formatTime}}</b> left to accept or decline the purchase. You will be notified of their decision via alert and email.
            </div>
            <ng-container>
               <div class="element-detail">
                 <div *ngIf="offer!=null">
                   <p class="accountInfoBorder">Price</p>
                   <p class="subUniqueTitle grey-text"> {{offer.priceForBuyer() | currency:'USD':'symbol':'1.5-5'}}/kWh</p>
                   <p class="accountInfoBorder">Service Start</p>
                   <p class="subUniqueTitle grey-text">1st meter read on or after {{offer.termFrom |
                     date:'shortDate'}}</p>
                   <p class="accountInfoBorder">Service End</p>
                   <p class="subUniqueTitle grey-text">1st meter read on or after {{getTermTo(offer.termFrom,
                     offer.termPeriod) | date:'shortDate'}}</p>
                   <p class="accountInfoBorder">Term</p>
                   <p class="subUniqueTitle grey-text">{{offer.termPeriod}} months</p>
                   <p class="accountInfoBorder">Offer Duration</p>
                   <p class="subUniqueTitle grey-text">Good until {{offer.validDate | date:'shortDate'}}</p>
                   <div class="account-info-block">
                     <p class="card-block-background" [class]="(viewAccounts)?'':'view-closed'">Associated Accounts
                       <a [class]="(viewAccounts)?'collapse':'open'" (click)="viewAccounts=!viewAccounts"></a>
                     </p>
                     <div [class]="(viewAccounts)?'visible':'hidden'">
                        <kilowant-accounts-listing [accounts]="offer.accounts"></kilowant-accounts-listing>
                     </div>
                   </div>
                 </div>
               </div>
            </ng-container>          
      </div>
    </div>
    <div class="block-buttons full-width under-card" *ngIf="offer!=null && !verificationPhase">
         <button type="button" (click)="gotoEditOffer(offer.id)">Edit</button>
         <button type="button" (click)="deleteBuyOffer(offer.id)">Delete</button>
    </div>
  </div>